import { useState, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import NiceModal from "@ebay/nice-modal-react";
import ModalManager from "@ebay/nice-modal-react";
import ApiModal from "/src/components/modal/ApiModal/ApiModal";
import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import PoleModal from "../PoleModal/PoleModal";
import poleAdminService from "../../services/poleAdminService";
import { useToastDispatchContext } from "/src/layouts/toast/context/toastContext";
import "./PoleTable.css";

function PoleTable() {
    const toast = useToastDispatchContext();
    const { getPoles, deletePole } = poleAdminService;
    const [rows, setRows] = useState([]);

    useEffect(() => {
        const fetchPoles = async () => {
            const [response, error] = await getPoles();
            if (error || !response) {
                toast.error("Error", "Unable to load poles");
                return;
            }
            setRows(response || []);
        };
        fetchPoles();
    }, []);

    const onClickAdd = () =>
        NiceModal.show(PoleModal, { title: "Create a new pole" })
            .then((pole) => setRows((prev) => [pole, ...prev]));

    const onClickUpdate = (row) =>
        NiceModal.show(PoleModal, { title: "Edit pole", data: row })
            .then((pole) => setRows((prev) => prev.map((r) => (r.id === pole.id ? pole : r))));

    const onClickDelete = (row) =>
        ModalManager.show(ApiModal, {
            title: "Delete pole " + row.name,
            body: "Do you really want to delete the pole \"" + row.name + "\" ? Its agents will no longer belong to any pole.",
            api: { request: deletePole, param: [row.id] },
            buttons: [
                { className: "validate", label: "Cancel", style: { marginRight: "20px" } },
                { className: "cancel", label: "Delete", type: "submit" },
            ],
        }).then((res) => {
            if (res?.error != null) {
                toast.error("Error", res.error);
                return;
            }
            setRows((prev) => prev.filter((r) => r.id !== row.id));
        });

    const columnDefs = [
        { headerName: "Name", field: "name", flex: 1, sortable: true, filter: true, floatingFilter: true },
        { headerName: "Description", field: "description", flex: 1.5, sortable: true, filter: true, floatingFilter: true },
        {
            headerName: "Leaders", flex: 1, sortable: true,
            valueGetter: (params) => (params.data?.leaders || []).map((l) => l.email).join(", "),
        },
        {
            headerName: "Agents", flex: 1,
            valueGetter: (params) => params.data?.agents?.length || 0,
        },
        {
            headerName: "Actions",
            width: 100,
            pinned: "right",
            cellRenderer: (params) => (
                <div style={{ display: "flex", gap: "5px", justifyContent: "center" }}>
                    <i className="fas fa-edit action-button blue" onClick={() => onClickUpdate(params.data)} />
                    <i className="fas fa-trash action-button red" onClick={() => onClickDelete(params.data)} />
                </div>
            ),
        },
    ];

    return (
        <div className="pole-admin-grid-section">
            <div className="pole-admin-toolbar">
                <IconButton
                    className="main-iconButton profil_action pole-admin-add-button"
                    icon="fas fa-plus"
                    onClick={onClickAdd}
                    title="Add pole"
                />
            </div>
            <div className="ag-theme-alpine pole-admin-grid" style={{ width: "100%", height: "550px" }}>
                <AgGridReact
                    enableCellTextSelection={true}
                    rowData={rows}
                    rowHeight={48}
                    columnDefs={columnDefs}
                    defaultColDef={{ sortable: true, filter: true, resizable: true }}
                    pagination={true}
                    paginationPageSize={50}
                />
            </div>
            <br></br>
        </div>
    );
}

export default PoleTable;
